










import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';

import BrandDetailsPopup from '@/components/Brands/BrandDetailsPopup.vue';
import { Brand, BrandIndexItem, BrandQueryResultItem, PropertyDelta } from '@/api/braendz';
import { DeltaType } from '@/models/Delta';

@Component({
    components: {
        BrandDetailsPopup
    }
})
export default class BrandDetailsButton extends Vue {
    // Data
    public showPopup = false;

    // Properties
    @Prop({ required: true })
    public type!: 'text';

    @Prop({ required: true })
    public brand!: BrandQueryResultItem | BrandIndexItem | Brand | null | undefined;

    // Getter
    public get brandId(): string | null {
        return this.$braendz.getBrandId(this.brand);
    }

    public get deltaType(): DeltaType {
        if(!this.brand) {
            return null;
        }

        if("deltaType" in this.brand && this.brand.deltaType) {
            return (this.brand.deltaType as 'Added' | 'Removed' | 'Changed' | 'None') ?? null;
        }

        return null;
    }

    public get propertyDeltas(): PropertyDelta[] | null {
        if(this.brand && "propertyDeltas" in this.brand) {
            return this.brand.propertyDeltas ?? null;
        }
        return null;
    }
}
